<template>
  <component :is="linkTag" v-bind="linkProps">
    <output class="stat-box__output"
      >{{ statString(stat.title) }} <em v-if="stat.has_plus" class="stat-box__suffix">+</em></output
    >
    <p>{{ stat.description }}</p>
  </component>
</template>

<script>
export default {
  name: 'Statistic',
  props: {
    stat: { type: Object, required: true },
  },
  computed: {
    parsedLink() {
      const { link } = this.stat
      if (!link) return { type: 'none', value: null }

      try {
        const url = new URL(link, window.location.origin)

        if (url.origin === window.location.origin) {
          return { type: 'internal', value: `${url.pathname}${url.search}${url.hash}` }
        }

        return { type: 'external', value: url.href }
      } catch (error) {
        return { type: 'none', value: null }
      }
    },
    linkTag() {
      if (this.parsedLink.type === 'internal') return 'RouterLink'
      if (this.parsedLink.type === 'external') return 'a'
      return 'div'
    },
    linkProps() {
      if (this.parsedLink.type === 'internal') {
        return { to: this.parsedLink.value }
      }

      if (this.parsedLink.type === 'external') {
        return { href: this.parsedLink.value }
      }

      return {}
    },
  },
  methods: {
    statString(stat) {
      switch (stat) {
        case '-1':
          return Object.keys(this.$beet.members).length
        case '-2':
          return Object.keys(this.$beet.projects).length
        default:
          return stat
      }
    },
  },
}
</script>
